<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap pl-6>
                <v-flex lg4 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-btn @click="filter_data" color="#3480c1" outlined>Xem</v-btn>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng số đơn đã cọc:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalOrder : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng tiền đơn hàng:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalAmount : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng tiền khách cọc:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalDeposit : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="text-error">
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng tiền ứng:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalAmount-item.TotalDeposit : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="text-red">
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng tiền phí dịch vụ:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalFeeBuy : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="text-error text-itatic">
                <v-flex lg12 sm12 pb-0 pt-0>
                    <v-card-title>(Thống kê tính theo ngày cọc đơn)</v-card-title>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        return {
            viewName: "thong-ke-tien-coc",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
        };
    },
    computed: {
        ...mapState({
            item: state => state.analytic.realtime_deposit.data,
            loading: state => state.analytic.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        roleAdmin() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
            };
            this.$store.dispatch("analytic/getRealtimeDeposit", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>